import React from "react";
import { FilterProps } from "../../commons/filters/index.js";
import { OrganisationMembersSelect } from "../organisations/OrganisationMembersSelect.js";

const FILTERS = { statuses: ["ACTIVATED" as const, "DEACTIVATED" as const] };

interface Props
  extends
    FilterProps<string[]>,
    Omit<React.ComponentProps<typeof OrganisationMembersSelect>, "onChange"> {}

export function FilterByOrganisationUsers({
  value,
  setValue,
  ...props
}: Props) {
  return (
    <OrganisationMembersSelect
      value={value}
      onChange={value => {
        setValue(value);
      }}
      filters={FILTERS}
      limitTags={2}
      {...props}
    />
  );
}
